import React from 'react'
import Label from 'components/Luxkit/Label/Label'
import styled from 'styled-components'
import Caption from 'components/Luxkit/Typography/Caption'
import LuxuryPlusLogo from './LuxuryPlusLogo'

const LabelElement = styled(Label)`
  background-color: ${props => props.theme.palette.product.loyalty};
  color: ${props => props.theme.palette.neutral.eight};
  border-color: ${props => props.theme.palette.product.loyalty}!important;
`

interface Props {
  type: 'insurance-discount' | 'exclusive-offers' | 'extra-inclusions' | 'extra-inclusions-for' | 'member' | 'discount';
}

function LuxuryPlusLabel({ type, ...rest }: Props) {
  return <LabelElement kind="tertiary" variant="grey" {...rest}>
    {type === 'insurance-discount' && <><Caption variant="medium" weight="bold">25% off insurance for</Caption> <LuxuryPlusLogo /></>}
    {type === 'exclusive-offers' && <><LuxuryPlusLogo /><Caption variant="medium" weight="bold">member only offer</Caption></>}
    {type === 'extra-inclusions' && <><LuxuryPlusLogo /><Caption variant="medium" weight="bold">extra inclusions</Caption></>}
    {type === 'extra-inclusions-for' && <><Caption variant="medium" weight="bold">Extra inclusions for</Caption><LuxuryPlusLogo /></>}
    {type === 'member' && <><LuxuryPlusLogo /> <Caption variant="medium" weight="bold">member</Caption></>}
  </LabelElement>
}

export default LuxuryPlusLabel
